import React from 'react';

interface UserAvatarProps {
  photoURL?: string;
  displayName?: string | null;
  size?: 'sm' | 'md' | 'lg';
  showRing?: boolean;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  photoURL,
  displayName,
  size = 'md',
  showRing = true
}) => {
  const sizeClasses = {
    sm: 'w-10 h-10 text-sm',
    md: 'w-12 h-12 text-base',
    lg: 'w-16 h-16 text-lg'
  };

  const ringClasses = showRing ? 'ring-3 ring-primary ring-offset-2' : '';

  const getInitials = (name: string | undefined | null) => {
    if (!name) return '?';
    const parts = name.split(' ');
    return parts
      .map(part => part.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2) || '?';
  };

  if (photoURL) {
    return (
      <img
        src={photoURL}
        alt={displayName || 'User'}
        className={`${sizeClasses[size]} rounded-full object-cover ${ringClasses}`}
      />
    );
  }

  return (
    <div
      className={`${sizeClasses[size]} rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center text-white font-semibold ${ringClasses}`}
    >
      {getInitials(displayName)}
    </div>
  );
};